"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuContent = void 0;
const react_1 = __importStar(require("react"));
const ui_components_1 = require("@groupby/ui-components");
const material_1 = require("@mui/material");
const classnames_1 = __importDefault(require("classnames"));
const menu_content_styles_1 = require("./menu-content.styles");
const loading_indicator_1 = require("../../loading-indicator");
const hooks_1 = require("../../../hooks");
const MenuContent = ({ options = [], onSelect, isDisabled, isLoading, isEmpty, isSearching, selectedIds = [], hasNextPage, moreItemsLoading, onLoadMore, singleSelect, }) => {
    const lastElementRef = (0, hooks_1.useLoadMore)({ hasNextPage, moreItemsLoading, onLoadMore });
    const isSelected = (0, react_1.useCallback)((id) => selectedIds.includes(id), [selectedIds]);
    // If singleSelect is true, uncheck all others when we check a new one.
    const handleCheckboxChange = (0, react_1.useCallback)((value, checked) => {
        if (singleSelect && checked) {
            selectedIds.forEach((id) => {
                if (id !== value) {
                    onSelect(id, false);
                }
            });
        }
        onSelect(value, checked);
    }, [singleSelect, selectedIds, onSelect]);
    const lastElementIndex = onLoadMore ? options.length - 1 : undefined;
    const menuOptions = (0, react_1.useMemo)(() => options.map(({ value, label, icon }, index) => {
        const checked = isSelected(value);
        return (react_1.default.createElement(material_1.FormControlLabel, { disableTypography: true, ref: lastElementIndex === index ? lastElementRef : undefined, key: value, control: react_1.default.createElement(ui_components_1.Checkbox, { className: singleSelect ? 'checkboxHidden' : '', checked: checked, disabled: isDisabled, onChange: (_e, isChecked) => handleCheckboxChange(value, isChecked) }), className: checked && singleSelect ? 'selected-item' : '', label: react_1.default.createElement(menu_content_styles_1.StyledTypography, { variant: "body2" }, label, icon) }));
    }), [
        options,
        isDisabled,
        isSelected,
        lastElementIndex,
        lastElementRef,
        handleCheckboxChange,
        singleSelect,
    ]);
    return (react_1.default.createElement(menu_content_styles_1.StyledMenuContent, { className: (0, classnames_1.default)('content', {
            'menu-content--searching': isSearching,
            'single-select': singleSelect,
        }) }, isLoading && isEmpty && react_1.default.createElement(loading_indicator_1.LoadingIndicator, { className: "loading-indicator" }), menuOptions, moreItemsLoading && react_1.default.createElement(loading_indicator_1.LoadingIndicator, { className: "loading-indicator" })));
};
exports.MenuContent = MenuContent;
exports.default = exports.MenuContent;
